import React from "react";

export type RouterHistoryContextData = {
  previousPath?: string;
} | null;

export const RouterHistoryContext =
  React.createContext<RouterHistoryContextData>(null);
